import { Role } from "@prisma/client";

export type SiteConfig = typeof siteConfig;

export const siteConfig = {
	name: "Paying Agency",
	caption: "Paying agency",
	description: "Save planet",
	
	links: {
		github: "https://github.com/nextui-org/nextui",
		twitter: "https://twitter.com/getnextui",
		docs: "https://nextui.org",
		discord: "https://discord.gg/9b6yyZKmH4",
		facebook: "https://discord.gg/9b6yyZKmH4",
		diia: "https://diia.gov.ua",
		dar: "https://dar.gov.ua/"
	},
};

export const AppUserRoles = [
    { label: 'All', value: '' }, 
	{ label: 'Administrator', value: Role.ADMINISTRATOR }, 
	{ label: 'Manager', value: Role.MANAGER }, 
	{ label: 'User', value: Role.USER },          
];

